<!-- Three equal tracks, of which only the first two are filled:

       | Current Organization | Destination fields | (empty) |

     The third track is deliberately unoccupied - no placeholder element, just a track nothing is
     placed into. That is what holds the destination fields in the middle of a wide dialog instead
     of letting them run the full width, and it costs no markup.

     The breakpoint is a CONTAINER query, not a `md:` utility. move-users-dialog gives this form
     `flex: 1; min-width: 300px`, so the window can be wide while the form itself is narrow - a
     viewport breakpoint would read the window and lay out three tracks in 300px. See the
     stylesheet; container queries are one of the few things a utility genuinely cannot express.

     The old split was a fixed 30/70. Thirty percent of a 300px container is 90px for an
     organization name plus its "Source Org" qualifier, which is where the overflow came from. -->
<div class="form-controls-container">
  <div class="form-columns">
    <!-- R1 - Current Organization (read-only).
         No [formGroup] here - this column holds no controls, and the directive was bound twice in
         the same template because both columns carried it.

         "Source Org" marks an organization that IS an affiliation source - derived, it is simply
         AutoAffiliatedOrgID <> 0. Passed as a suffix rather than concatenated onto the name: it
         qualifies the organization, it is not part of what the organization is called. -->
    <div class="min-w-0">
      <app-form-field
        fieldLabel="{{ 'MoveForms.LocationMove.CurrentOrganization' }}"
        [labelValue]="_initFormVM?.currentOrgName"
        [labelValueSuffix]="currentOrgSourceLabel"
        type="label"
      >
      </app-form-field>
    </div>

    <!-- R2 - Destination -->
    <div class="flex min-w-0 flex-col" [formGroup]="formGroup">
      <div
        class="billable-container flex flex-wrap items-start gap-x-4"
        *ngIf="showDestinationBillableOrg"
      >
        <!-- Billable Org -->
        <app-dropdown-form-field
          class="min-w-0 grow basis-48"
          formControlName="billableOrg"
          fieldLabel="{{ 'MoveForms.General.DestinationBillableOrg' }}"
          [formGroup]="formGroup"
          [placeholder]="'MoveForms.General.SelectBillableOrganiation'"
          [options]="billableOrgList"
          localizeOptions="false"
          (onFilter)="onBillableOrgDropDownFilter($event)"
          (selectionChange)="onBillableOrgValueChanged($event)"
        >
        </app-dropdown-form-field>

        <!-- Enable Edit -->
        <ng-container *ngIf="showEnableBillableOrgEdit">
          <app-form-field
            class="shrink-0"
            fieldLabel="{{ 'MoveForms.General.EnableEdit' }}"
            fieldControlName="isEditEnabled"
            type="checkbox"
            [formGroup]="formGroup"
            [labelPosition]="'before'"
            [formState]="false"
            col="2"
            #editEnabledRef
            (valueChanged)="onEnableEditValueChanged($event)"
            appAuthorization
            [policy]="securityPolicies.RequireSuperUser"
            [policyOptions]="{
              componentRef: editEnabledRef,
              policyAction: 'Disable',
            }"
          ></app-form-field>
        </ng-container>
      </div>

      <!-- Destination Organization -->
      <app-dropdown-form-field
        class="min-w-0"
        formControlName="org"
        fieldLabel="{{ 'MoveForms.General.DestinationOrganization' }}"
        [formGroup]="formGroup"
        [placeholder]="'MoveForms.General.SelectDestinationOrganization'"
        [options]="orgList"
        localizeOptions="false"
        (onFilter)="onDestinationOrgDropDownFilter($event)"
        (selectionChange)="onDestinationOrgValueChanged($event)"
      >
      </app-dropdown-form-field>
    </div>

    <!-- R3 is the third grid track, intentionally left empty. -->
  </div>
</div>
